import * as TabsPrimitive from "@radix-ui/react-tabs";
import { Button } from "../components/Button";
import { ScrollArea, ScrollBar } from "../components/ScrollArea";
import { cn } from "../lib/utils";
import { cva } from "class-variance-authority";
import * as React from "react";
const Tabs = TabsPrimitive.Root;
const tabsTriggerVariants = cva([
    "s-relative",
    "after:s-absolute after:s-bottom-[-10px] after:s-left-1/2 after:s-h-[2px]",
    "after:s-w-full after:s--translate-x-1/2",
    "after:s-bg-foreground after:s-opacity-0 data-[state=active]:after:s-opacity-100",
    "dark:after:s-bg-foreground-night",
], {
    variants: {
        variant: {
            ghost: "data-[state=inactive]:s-text-muted-foreground data-[state=inactive]:hover:s-text-primary-900 data-[state=inactive]:dark:s-text-muted-foreground-night data-[state=inactive]:dark:hover:s-text-primary-900-night",
            primary: "",
            highlight: "",
            "highlight-secondary": "",
            warning: "",
            "warning-secondary": "",
            outline: "",
            "ghost-secondary": "",
        },
    },
});
const tabsListVariants = cva("s-flex s-h-[45px] s-gap-2 s-w-full", {
    variants: {
        border: {
            true: "s-border-b s-border-border dark:s-border-border-night",
        },
    },
    defaultVariants: {
        border: true,
    },
});
const TabsList = React.forwardRef(({ className, border, ...props }, ref) => (React.createElement(ScrollArea, null,
    React.createElement(TabsPrimitive.List, { ref: ref, className: cn(tabsListVariants({ border }), className), ...props }),
    React.createElement(ScrollBar, { orientation: "horizontal", className: "s-hidden" }))));
TabsList.displayName = TabsPrimitive.List.displayName;
const TabsTrigger = React.forwardRef(({ className, label, tooltip, icon, href, target, rel, replace, shallow, disabled, variant = "ghost", isCounter = false, counterValue, ...props }, ref) => {
    return (React.createElement(TabsPrimitive.Trigger, { ref: ref, className: cn("disabled:s-pointer-events-none", className), disabled: disabled, asChild: true, ...props },
        React.createElement(Button, { variant: variant, size: "sm", label: label, tooltip: tooltip, icon: icon, disabled: disabled, href: href, target: target, rel: rel, replace: replace, shallow: shallow, isCounter: isCounter, counterValue: counterValue, className: cn(tabsTriggerVariants({ variant: variant !== null && variant !== void 0 ? variant : undefined }), className) })));
});
TabsTrigger.displayName = "TabsTrigger";
const TabsContent = React.forwardRef(({ className, ...props }, ref) => (React.createElement(TabsPrimitive.Content, { ref: ref, className: cn("s-contents s-ring-offset-background focus-visible:s-outline-none focus-visible:s-ring-2 focus-visible:s-ring-offset-2", className), ...props })));
TabsContent.displayName = TabsPrimitive.Content.displayName;
export { Tabs, TabsContent, TabsList, TabsTrigger };
//# sourceMappingURL=Tabs.js.map